import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { reportTypes, reportFormat } from 'src/app/utils/constants/strings';
import { ReportsService } from '../service/reports/reports.service';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { formatDate } from '@angular/common';
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-create-reports',
  templateUrl: './create-reports.component.html',
  styleUrls: ['./create-reports.component.css'],
})
export class CreateReportsComponent implements OnInit {
  maxDate: any;
  fromdate: any;
  todate: any;
  today = new Date();
  daysDiffError: boolean;
  unMappedFields = [];
  mappedFields: any = [];
  reportsDetailsForm: FormGroup;
  reportTypesVal: any = reportTypes;
  bbxuserrole: string;
  reportFormatVal = reportFormat;
  mandatoryFileds = [];
  reportParamsVal;
  reportParamsReq = [];
  selectedReportType: string;
  setReportConfigAlert: boolean;
  constructor(
    private fb: FormBuilder,
    private reportService: ReportsService,
    private errorDialogService: ErrorDialogService,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.initializationformGroup();
    this.bbxuserrole = sessionStorage.getItem('bbx-role');
    if (this.bbxuserrole === 'OPS_USER' || this.bbxuserrole === 'CUSTOMER_IT_ADMIN') {
      const indexOfReportType = this.reportTypesVal.map(x => x.value).indexOf('SHIPMENTS_SUMMARY');
      if (indexOfReportType > -1) {
        this.reportTypesVal.splice(indexOfReportType, 1);
      }
    }
    this.getReportsConfiguration();
  }

  initializationformGroup() {
    this.reportsDetailsForm = this.fb.group({
      reportType: ['', Validators.required],
      reportFormat: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      if (this.isFieldMandatory(event.previousContainer.data[event.previousIndex])) {
        return;
      } else {
        const previousIndexValue = event.previousContainer.data[event.previousIndex];
        if (previousIndexValue === 'Blank' && event.previousContainer.id === 'cdk1') {
          this.mappedFields.splice(event.currentIndex, 0, previousIndexValue);
          return;
        }
        if (previousIndexValue === 'Blank' && event.previousContainer.id === 'cdk2') {
          this.mappedFields.splice(event.previousIndex, 1);
          return;
        }

        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
    }
  }

  generateReport() {
    const Body: any = {};
    Body.fromdate = formatDate(this.reportsDetailsForm.value.startDate, 'yyyyMMdd', 'en_US');
    Body.todate = formatDate(this.reportsDetailsForm.value.endDate, 'yyyyMMdd', 'en_US');
    Body.reportType = this.reportsDetailsForm.value.reportType;
    Body.reportFormat = this.reportsDetailsForm.value.reportFormat;
    this.reportParamsReq = [];
    Body.reportParams = [];
    for (const mappingObjIndex of this.mappedFields) {
      for (const eachVal of this.reportParamsVal) {
        if (eachVal.column_name == mappingObjIndex) {
          const fieldsObj: any = {};
          fieldsObj.field_name = eachVal.field_name;
          fieldsObj.required = eachVal.required;
          fieldsObj.column_name = eachVal.column_name;
          this.reportParamsReq.push(fieldsObj);
        }
      }
    }
    Body.reportParams = this.reportParamsReq;
    this.reportService.getReports(Body).subscribe({
      next: _data => {
        if (_data) {
          this.errorDialogService.openDialog(this.selectedReportType + ' ' + _data, false);
          this.reportsDetailsForm.reset();
          this.mappedFields = [];
          this.unMappedFields = [];
        }
      },
    });
  }

  getReportParams(event) {
    this.reportParamsVal = [];
    this.mappedFields = [];
    this.unMappedFields = [];
    this.mandatoryFileds = [];
    if (event?.value) {
      const rpVal = this.reportTypesVal?.find(element => element.value === event?.value);
      this.selectedReportType = rpVal?.type;
      this.reportService.getReportHeaders(event?.value).subscribe({
        next: responseData => {
          if (responseData[0].data && responseData[0].data.length > 0) {
            this.reportParamsVal = responseData[0].data;
            if (this.reportParamsVal) {
              this.mapOptionData(this.reportParamsVal);
            }
          }
        },
      });
    }
  }

  mapOptionData(mappingData) {
    this.mappedFields = [];
    this.unMappedFields = [];
    this.mandatoryFileds = [];
    for (const mappingObj of mappingData) {
      if (mappingObj.required === 'M') {
        this.mappedFields.push(mappingObj.column_name);
        this.mandatoryFileds.push(mappingObj.column_name);
      } else {
        this.unMappedFields.push(mappingObj.column_name);
      }
    }
  }

  isFieldMandatory(field) {
    return this.mandatoryFileds.includes(field);
  }

  resetMaxDate() {
    if (this.reportsDetailsForm.get('endDate').value) {
      this.maxDate = new Date();
      this.daysDiff();
    }
  }

  setMaxDate() {
    this.maxDate = new Date();
    const tempdate = new Date(this.reportsDetailsForm.get('startDate').value);
    if (tempdate.getMonth() == this.today.getMonth()) {
      tempdate.setDate(this.maxDate.getDate());
    } else {
      tempdate.setDate(tempdate.getDate() + 30);
      if (tempdate > this.today) {
        tempdate.setDate(this.maxDate.getDate());
      }
    }
    this.maxDate = new Date(tempdate);
  }

  daysDiff() {
    const diffDays: any = Math.floor(
      (this.reportsDetailsForm.value.endDate - this.reportsDetailsForm.value.startDate) /
        (1000 * 60 * 60 * 24)
    );
    if (diffDays > 30) {
      this.daysDiffError = true;
    } else {
      this.daysDiffError = false;
    }
  }
  getReportsConfiguration() {
    this.configService.getConfig('report_configuration').subscribe(response => {
      if (response && response[0].data && response[0]?.data[0]?.EmailList?.length > 0) {
        this.setReportConfigAlert = false;
      } else {
        this.setReportConfigAlert = true;
      }
    });
  }
}
